module.exports = __webpack_public_path__ + "static/serverBio4-cbf2da71da992b05e43f0c18410fbcdd.png";